import { useCallback, useSyncExternalStore } from 'react';
import { playerPlaybackRateStore, setPlayBackSpeed } from '@/App/remotion/MainPlayer/stores/playerPlaybackRateStore';

export const PLAYBACK_SPEED_OPTIONS = [2, 1.5, 1.25, 1, 0.75, 0.5] as const;
export type PlaybackSpeed = (typeof PLAYBACK_SPEED_OPTIONS)[number];

export const useRemotionPlayerPlaybackRate = () => {
  const playbackRate = useSyncExternalStore(playerPlaybackRateStore.subscribe, playerPlaybackRateStore.getSnapshot);

  const setPlaybackRate = useCallback((rate: PlaybackSpeed) => {
    setPlayBackSpeed(rate);
  }, []);

  return { playbackRate, setPlaybackRate };
};
